import { useMediaQuery } from '@mui/material';
import CoverageTableDesktop from 'components/CoverageTable/components/CoverageTableDesktop/CoverageTableDesktop';
import { CoverageTableMobile } from 'components/CoverageTable/components/CoverageTableMobile';
import theme from 'providers/theme/theme';
import type { FC } from 'react';
import type { CoverageTableProps } from './CoverageTable.types';

const CoverageTable: FC<CoverageTableProps> = (props) => {
  const isTabletLayout = useMediaQuery(theme.breakpoints.down('md'));

  return isTabletLayout ? <CoverageTableMobile {...props} /> : <CoverageTableDesktop {...props} />;
};

export default CoverageTable;
